export default defineNuxtPlugin((nuxtApp) => {
  const { loadHelpScout } = useHelpScout()

  nuxtApp.hook('app:mounted', (context) => {
    loadHelpScout()
  })
})
